import { Routes } from '@angular/router';
import { authGuard, roleGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./public/public-home/public-home.component').then(
        (m) => m.PublicHomeComponent
      ),
  },
  {
    path: 'reports',
    loadComponent: () =>
      import('./public/public-feed/public-feed.component').then(
        (m) => m.PublicFeedComponent
      ),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./dashboard/dashboard.component').then(
        (m) => m.DashboardComponent
      ),
  },
  {
    path: 'company/dashboard',
    canActivate: [roleGuard(['COMPANY_REP'])],
    loadComponent: () =>
      import('./company/company-dashboard/company-dashboard.component').then(
        (m) => m.CompanyDashboardComponent
      ),
  },
  {
    path: 'reports/new',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./reports/report-form/report-form.component').then(
        (m) => m.ReportFormComponent
      ),
  },
  {
    path: 'reports/:id/edit',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./reports/report-form/report-form.component').then(
        (m) => m.ReportFormComponent
      ),
  },
  {
    path: 'reports/:id/view',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./reports/report-view/report-view.component').then(
        (m) => m.ReportViewComponent
      ),
  },
  {
    path: 'reports/:id',
    loadComponent: () =>
      import('./public/report-detail/report-detail.component').then(
        (m) => m.ReportDetailComponent
      ),
  },
  {
    path: 'reports/:id/issue',
    loadComponent: () =>
      import('./public/report-issue/report-issue.component').then(
        (m) => m.ReportIssueComponent
      ),
  },
  {
    path: 'companies/:slug',
    loadComponent: () =>
      import('./companies/company-profile/company-profile.component').then(
        (m) => m.CompanyProfileComponent
      ),
  },
  {
    path: 'moderation',
    canActivate: [roleGuard(['MODERATOR', 'ADMIN'])],
    loadComponent: () =>
      import('./moderation/moderation-queue/moderation-queue.component').then(
        (m) => m.ModerationQueueComponent
      ),
  },
  {
    path: 'moderation/reports/:id',
    canActivate: [roleGuard(['MODERATOR', 'ADMIN'])],
    loadComponent: () =>
      import('./moderation/report-review/report-review.component').then(
        (m) => m.ReportReviewComponent
      ),
  },
  {
    path: 'moderation/breadcrumbs',
    canActivate: [roleGuard(['ADMIN'])],
    loadComponent: () =>
      import('./moderation/breadcrumbs-list/breadcrumbs-list.component').then(
        (m) => m.BreadcrumbsListComponent
      ),
  },
  {
    path: 'moderation/breadcrumbs/:sessionId',
    canActivate: [roleGuard(['ADMIN'])],
    loadComponent: () =>
      import('./moderation/breadcrumbs-detail/breadcrumbs-detail.component').then(
        (m) => m.BreadcrumbsDetailComponent
      ),
  },
  {
    path: 'moderation/takedowns/:id',
    canActivate: [roleGuard(['MODERATOR', 'ADMIN'])],
    loadComponent: () =>
      import('./moderation/takedown-review/takedown-review.component').then(
        (m) => m.TakedownReviewComponent
      ),
  },
  {
    path: 'privacy',
    loadComponent: () =>
      import('./shared/privacy-policy/privacy-policy.component').then(
        (m) => m.PrivacyPolicyComponent
      ),
  },
  {
    path: 'terms',
    loadComponent: () =>
      import('./shared/terms/terms.component').then((m) => m.TermsComponent),
  },
  {
    path: 'transparencia-salarial',
    loadComponent: () =>
      import(
        './shared/salary-transparency-guidelines/salary-transparency-guidelines.component'
      ).then((m) => m.SalaryTransparencyGuidelinesComponent),
  },
  {
    path: 'sinais',
    loadComponent: () =>
      import('./shared/recruitment-flags/recruitment-flags.component').then(
        (m) => m.RecruitmentFlagsComponent
      ),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
